const DatePickerWidth = 384;

export const setPositions = (
  position = 'left-end',
  container?: HTMLDivElement,
  trigger?: HTMLElement | null
) => {
  if (!trigger || !container) {
    return { left: 0, top: 0 };
  }
  const triggerBounds = trigger.getBoundingClientRect();

  const triggerOffsetTop = trigger.getBoundingClientRect()?.top;
  const triggerOffsetLeft = trigger.getBoundingClientRect()?.left;
  const bodyHeight = document.body.clientHeight;
  const bodyWidth = document.body.clientWidth;
  const datePickerHeight = 484;

  let left = 0;
  let top;
  let height;
  let width;

  switch (position) {
    case 'right-start':
    case 'left-start':
      top = triggerOffsetTop;
      // Switch to right if overflow from bottom
      if (top + datePickerHeight > bodyHeight) {
        top =
          triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
      }
      // }Switch to right-end if still overflowing from bottom
      if (top + datePickerHeight > bodyHeight) {
        top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
      }
      break;
    case 'right-end':
    case 'left-end':
      top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
      // Switch to right/left (center) if overflowing from top
      if (top < 0) {
        top =
          triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
      }
      // Switch to right-start/left-start if again overflowing
      if (top < 0) {
        top = triggerOffsetTop;
      }

      // Check if overflow from right
      if (left + DatePickerWidth > bodyWidth) {
        left = triggerOffsetLeft - DatePickerWidth;
      }
      break;
    case 'right':
    case 'left':
      top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
      // If overflow from top set to right start / left-start
      if (
        triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2 <
        0
      ) {
        top = triggerOffsetTop;
      }
      // If overflow from bottom set right-end /left-end
      if (
        triggerOffsetTop + triggerBounds.height / 2 + datePickerHeight / 2 >
        bodyHeight
      ) {
        top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
      }
      break;

    case 'top-start':
    case 'bottom-start':
      left = triggerOffsetLeft;
      if (left + DatePickerWidth > bodyWidth) {
        left =
          triggerOffsetLeft + triggerBounds.width / 2 - DatePickerWidth / 2;
      }
      if (left + DatePickerWidth > bodyWidth) {
        left = triggerOffsetLeft + triggerBounds.width - DatePickerWidth;
      }
      break;

    case 'top-end':
    case 'bottom-end':
      left = triggerOffsetLeft + triggerBounds.width - DatePickerWidth;
      if (left < 0) {
        left =
          triggerOffsetLeft + triggerBounds.width / 2 - DatePickerWidth / 2;
      }
      if (left < 0) {
        left = triggerOffsetLeft;
      }
      break;
    case 'top':
    case 'bottom':
      left = triggerOffsetLeft + triggerBounds.width / 2 - DatePickerWidth / 2;
      if (left < 0) {
        left = triggerOffsetLeft;
      }
      if (left + DatePickerWidth > bodyWidth) {
        left = triggerOffsetLeft + triggerBounds.width - DatePickerWidth;
      }

      break;
  }

  // Primary axis and flips on overflow
  switch (position) {
    case 'right':
    case 'right-start':
    case 'right-end':
      left = triggerOffsetLeft + triggerBounds.width;
      if (left + DatePickerWidth > bodyWidth) {
        left = triggerOffsetLeft - DatePickerWidth;
      }
      break;
    case 'left':
    case 'left-start':
    case 'left-end':
      left = triggerOffsetLeft - DatePickerWidth;
      if (left < 0) {
        left = triggerOffsetLeft + triggerBounds.width;
      }
      break;
    case 'top-start':
    case 'top':
    case 'top-end':
      top = triggerOffsetTop - datePickerHeight;
      if (top < 0) {
        top = triggerOffsetTop + triggerBounds.height;
      }
      break;
    case 'bottom-start':
    case 'bottom':
    case 'bottom-end':
      top = triggerOffsetTop + triggerBounds.height;
      if (top + datePickerHeight > bodyHeight) {
        top = triggerOffsetTop - datePickerHeight;
      }
      break;
    default:
      top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
      left = triggerOffsetLeft + triggerBounds.width;
  }

  return { left, top, maxHeight: height, maxWidth: width };
};
